export const CONTACTS = {
  omar: { name: "Omar", role: "Shop Lead & Dispatch", phone: "(909) 832-4486", tel: "tel:+19098324486" },
  ray: { name: "Ray", role: "Towing & Recovery", phone: "(956) 252-6750", tel: "tel:+19562526750" },
};

export const ADDRESS = "2273 S Cactus Ave, Bloomington, CA 92316";
export const MAPS_URL = "https://maps.google.com/?q=2273+S+Cactus+Ave,+Bloomington,+CA+92316";
export const MAPS_EMBED = "https://maps.google.com/maps?q=2273%20S%20Cactus%20Ave%2C%20Bloomington%2C%20CA%2092316&t=&z=14&ie=UTF8&iwloc=&output=embed";
export const HOURS = "Shop: Mon – Sat, 7:00 AM – 6:00 PM  •  Towing: 24 Hours / 7 Days";

export const SERVICES = [
  {
    id: "computer-diagnostics",
    num: "01",
    title: "Computer Diagnostics & General Repair",
    short: "OEM-level ECU scan tools for Cummins, Detroit Diesel, PACCAR, International, Volvo, and Mack. Instant fault code clearing & live sensor telemetry.",
    detail: "Dealer-grade diagnostic laptops plug straight into your rig's ECU. We read live sensor telemetry, trace intermittent electrical faults, clear derate codes, and verify repairs with a full post-repair scan — no guesswork, no parts cannon.",
    tags: ["ECU Scans", "Fault Codes", "Live Telemetry", "Electrical"],
    image: "https://images.unsplash.com/photo-1770705950498-d373e33ecb1a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "engines-overhaul",
    num: "02",
    title: "Engine Repair & Major Overhauls",
    short: "In-frame and out-of-frame overhauls. Cylinder head repair, turbocharger installation, fuel injector sync, and top-end calibration.",
    detail: "From blown turbos to full in-frame rebuilds, we machine, measure, and torque to OEM spec. Cylinder heads, injectors, liners, bearings — every component inspected and documented before your engine goes back to work.",
    tags: ["In-Frame Overhaul", "Turbos", "Injectors", "Cylinder Heads"],
    image: "https://images.pexels.com/photos/7019598/pexels-photo-7019598.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    id: "suspensions-steering",
    num: "03",
    title: "Suspensions & Heavy Steering",
    short: "Air bag replacements, leaf spring installation, kingpins, tie rods, alignment diagnostics, and heavy-duty frame balance.",
    detail: "A wandering rig burns tires and drivers. We rebuild front ends — kingpins, bushings, tie rods, drag links — replace air bags and leaf packs, and set your axle geometry so the truck tracks straight under full load.",
    tags: ["Air Bags", "Leaf Springs", "Kingpins", "Alignment"],
    image: "https://images.pexels.com/photos/7019365/pexels-photo-7019365.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    id: "clutches-drivetrain",
    num: "04",
    title: "Clutches & Drivetrain Systems",
    short: "Heavy-duty Eaton Fuller clutch replacement, flywheel resurfacing, driveshaft balancing, u-joints, and torque adjustment.",
    detail: "Slipping clutch under load? We drop, resurface, and reset — Eaton Fuller clutches, flywheels, driveshafts, and u-joints balanced and torqued so power reaches the pavement without shudder or vibration.",
    tags: ["Eaton Fuller", "Flywheels", "Driveshafts", "U-Joints"],
    image: "https://images.pexels.com/photos/7564858/pexels-photo-7564858.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    id: "transmissions-differentials",
    num: "05",
    title: "Transmissions & Differentials",
    short: "Manual, AMT, and automatic transmission rebuilds & fluid service. Differential gear swaps and axle seal replacements.",
    detail: "Grinding gears, slipping AMTs, howling diffs — we've rebuilt them all. Full transmission teardowns, gear ratio swaps for fuel economy or pull power, and axle services that keep your drivetrain quiet and cool.",
    tags: ["Rebuilds", "AMT Service", "Gear Swaps", "Axle Seals"],
    image: "https://images.unsplash.com/photo-1708745427274-d5de5122fd57?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "247-towing-recovery",
    num: "06",
    title: "24/7 Heavy Duty Towing Service",
    short: "Heavy wrecker & rotator service for semi trucks, trailers, box trucks, and loaded rigs. Fast dispatch on I-10, I-15, and CA-60.",
    detail: "Stranded with a full load at 3 AM? Our heavy wreckers run around the clock across the Inland Empire. Semis, loaded trailers, buses, construction equipment — we recover, tow, and deliver to our shop or yours.",
    tags: ["Heavy Wreckers", "Recovery", "24/7 Dispatch", "I-10 / I-15"],
    image: "https://images.unsplash.com/photo-1626121300305-def4dc305387?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

export const MARQUEE_PHRASES = [
  "COMPUTER DIAGNOSTICS",
  "ENGINE OVERHAULS",
  "24/7 HEAVY DUTY TOWING",
  "TRANSMISSIONS & DIFFERENTIALS",
  "SUSPENSION & CLUTCHES",
  "BLOOMINGTON CA",
];
